import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-page big"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_KeyCountryIndicatorForm = _resolveComponent("KeyCountryIndicatorForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageTitle, {
      dense: "",
      title: "Ключевой показатель страны"
    }),
    (_ctx.isAccessAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_KeyCountryIndicatorForm, {
            onSave: _ctx.save,
            isLoading: _ctx.isLoading
          }, null, 8, ["onSave", "isLoading"])
        ]))
      : _createCommentVNode("", true)
  ]))
}